/* eslint react-hooks/exhaustive-deps: "warn" */

import { type ReactNode } from 'react';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './TeamUseCasesSection.module.scss';

export type TeamUseCase = {
  team: string;
  title: string;
  description: ReactNode;
};

type Props = {
  title: ReactNode;
  description?: ReactNode;
  items: TeamUseCase[];
};

export const TeamUseCasesSection = ({ title, description, items }: Props) => (
  <Section className={styles.root}>
    <div className={styles.head}>
      <TitleBlock title={title} description={description} align="left" />
    </div>

    <div className={styles.grid}>
      {items.map((item, i) => (
        <div key={item.team} className={styles.card}>
          <span className={styles.ghostIndex} aria-hidden="true">
            {String(i + 1).padStart(2, '0')}
          </span>

          <span className={styles.team}>{item.team}</span>
          <h3 className={styles.cardTitle}>{item.title}</h3>
          <p className={styles.cardDescription}>{item.description}</p>
        </div>
      ))}
    </div>
  </Section>
);
